import { FaWhatsapp } from "react-icons/fa";
import { WHATSAPP_NUMBER, WHATSAPP_DEFAULT_MESSAGE } from "../constants/contact";
import "../styles/components/FloatingWhatsApp.scss";

function FloatingWhatsApp() {
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_DEFAULT_MESSAGE
  )}`;

  return (
    <a
      className="floating-whatsapp"
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Luma3D on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
}

export default FloatingWhatsApp;
